// extracted by mini-css-extract-plugin
export default {"button":"detailsCard_button__4a-sO","topMargin":"detailsCard_topMargin__tE387"};